var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLawfully(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.743 0v7.37L13.2 8.967v7.658l3.743 2.43V4.024L10.743 0z",
    fill: "url(#lawfully_svg__paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.944v15.031l6.2 4.023v-7.374l-2.457-1.592V7.37L7 4.944z",
    fill: "url(#lawfully_svg__paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.743 15.032l2.457 1.592V8.966l-2.457-1.595v7.66z",
    fill: "#60F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lawfully_svg__paint0_linear",
    x1: 8.503,
    y1: 10.434,
    x2: 20.602,
    y2: 14.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#6E06F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#8216DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A331B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#D0557A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lawfully_svg__paint1_linear",
    x1: 2.421,
    y1: 15.416,
    x2: 14.391,
    y2: 19.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#15B4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2A85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#444CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#5623FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#6209FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60F"
  })))));
}
export default SvgLawfully;